(function ($) {
	const sitemapSubItems = $('.sitemap ul li.page_item_has_children > a');
	const sitemapItems = $('.sitemap .tab-content ul li a');

	sitemapSubItems.each(function () {
		$('<span></span>')
			.on('click', function (event) {
				event.preventDefault();
				$(this).toggleClass('open');
				$(this).parent().next().first().slideToggle();
			})
			.prependTo($(this));
	});

	sitemapItems.each(function () {
		$(`<span class="path-name">${$(this)[0].pathname.replace(/\/$/, '')}</span>`).appendTo($(this));
	});
}(jQuery));